import React from 'react'
import PropTypes from 'prop-types'
import Sidebar from '../sidebar/sidebar'
import Navbar from '../navbar/navbar'
import { SidebarProvider } from '../../context/sidebar/SidebarContext'
import Marquee from '../marquee/marquee'
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary'

const Layout = ({ children }) => {
  return (
    <SidebarProvider>
      {/* <Marquee /> */}
      <div
        className="layout-container"
        // remove this for .work
        style={{
          // marginTop: '80px',
        }}
      >
        <Sidebar />
        <div className="main-content">
          <Navbar />
          <ErrorBoundary>
            <main className="page-content">{children}</main>
          </ErrorBoundary>
        </div>
      </div>
    </SidebarProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
